export const timelineEvents = [
  {
    year: "2018",
    title: "Foundation",
    description: "TWA began its efforts in St. Louis in April 2018 by partnering with the U.S. Attorney's Office and federal and state probation and parole offices to sponsor the inaugural Second Chance Job Fair at Chaifetz Arena."
  },
  {
    year: "2019",
    title: "Growth",
    description: "The St. Louis Second Chance Job Fair drew 1,000 attendees, including 77 employers committed to looking at candidates holistically. TWA expanded to provide year-round job search assistance."
  },
  {
    year: "2020",
    title: "Innovation",
    description: "TWA quickly pivoted to an innovative virtual format when the April job fair was impacted by pandemic restrictions, incorporating video resumes and volunteer job coaches."
  },
  {
    year: "2021",
    title: "Expansion",
    description: "In addition to two job fairs and year-round services, TWA began a pilot program serving individuals inside the St. Louis County Justice Center pre-release and developed employer training programs."
  },
  {
    year: "2022",
    title: "Funding",
    description: "TWA received generous funding from the Lutheran Foundation, the Pershing Charitable Trust, and other foundations to increase capacity and hire additional staff."
  },
  {
    year: "2023",
    title: "Institutional Partnerships",
    description: "TWA began working with five Missouri Department of Corrections institutions, preparing participants through pre-release services and connecting them with employment opportunities."
  },
  {
    year: "2024",
    title: "Statewide Impact",
    description: "TWA was awarded funding for statewide expansion by MO DOC, with employment specialists working in St. Louis, Kansas City, Columbia, and Springfield."
  }
];

export const institutions = [
  "Farmington Correctional Center (FCC)",
  "Missouri Eastern Correctional Center in Pacific (MECC)",
  "Northeast Correctional Center in Bowling Green (NECC)",
  "Transition Center of St. Louis (TCSTL)",
  "Women's Eastern Reception, Diagnostic and Correctional Center in Vandalia (WERDCC)"
];

export const impactStats = [
  { number: "7.1%", label: "Recidivism Rate", description: "For participants employed with TWA partners" },
  { number: "$3,146", label: "Employer Savings Per Hire", description: "Through tax credits and reduced turnover costs" },
  { number: "76%", label: "Job Fair Employment Rate", description: "Within two months for jobseekers who follow up" },
  //{ number: "4", label: "Missouri Locations", description: "St. Louis, Kansas City, Columbia, Springfield" }
];

export const testimonials = [
  {
    quote: "Working with TWA, changed my life. It connected me with great opportunities and kept me away from negative influences and on the right track. It also gave me a job that kept me busy. ",
    name: "- Gerarrd, job seeker.",
    role: "Now Employed in Construction"
  },
  {
    quote: "The support I received from TWA made all the difference. They saw my potential, not just my past.",
    name: "- Program Graduate",
    role: "Currently in Manufacturing"
  },
  {
    quote: "Working with TWA opened doors I never thought would be available to me. I'm grateful for their belief in second chances.",
    name: "- TWA Alumni",
    role: "Retail Management"
  }
];

export const updatedImpactStats = [
    {
      number: "278",
      label: "JOBSEEKERS EMPLOYED",
      description: "Since 2020, successfully placed in meaningful employment"
    },
    {
      number: "4%",
      label: "RECIDIVISM RATE",
      description: "Compared to Missouri's most recent rate of 32%"
    },
    {
      number: "76%",
      label: "EMPLOYMENT SUCCESS",
      description: "Of jobseekers employed within 2 months of engagement"
    },
    {
      number: "$15.01",
      label: "AVERAGE HOURLY WAGE",
      description: "With trades program participants earning $21/hour"
    }
  ];

  // New program updates data
  export const programUpdates = [
    "Continued leveraging technology, including video resumes",
    "Expanded pre-release work to 4 MO prisons + Transition Center + St. Louis County Jail", 
    "Added new Employment Specialist and Outreach Coordinator positions to increase capacity"
  ];

  // Job fair statistics
  export const jobFairStats = [
    { number: "31", label: "NEW EMPLOYERS", description: "Opening opportunities" },
    { number: "60", label: "JOBSEEKERS TRAINED", description: "Job fair participants" },
    { number: "75", label: "JOB COACHES", description: "Supporting jobseekers" },
    { number: "148", label: "CEREMONY PARTICIPANTS", description: "Job fair graduates" }
  ];

  // Updated testimonials with new quote
  export const updatedTestimonials = [
    ...testimonials,
    {
      quote: "I am thankful for the opportunity I got and everything the TWA did to help me. It gave me hope not to give up on my dreams.",
      name: "TWA Jobseeker",
      role: "Program Participant"
    }
  ];

  // Sponsors and partners
  export const sponsors = [
    "Missouri Department of Corrections",
    "Missouri Department of Higher Education and Workforce Development", 
    "Pershing Foundation",
    "Lutheran Foundation",
    "Stanley Black and Decker"
  ];

  export const jobFairSponsors = [
    "Walmart", "Jack & Rachel Oliver", "Clark Fox Family Foundation", 
    "Katie Sinquefield", "Regional Business Council", "US Bank"
  ];